// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2cR0l","selected":"Chip_selected__22UUi"};